import styled from 'styled-components'
import {Link} from 'react-scroll'
// import {Link} from 'react-router-dom';

export const Button = styled.a`
    border-radius: 50px;
    background: ${({primary}) => (primary ? '#88b3c6' : '#283b71')};
    white-space: nowrap;
    padding: ${({big}) => (big ? '14px 48px' : '12px 30px')};
    color: ${({dark}) => (dark ? '#010606': '#fff')};
    font-size: ${({fontBig}) => (fontBig ? '20px' : '16px')};
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    border: ${({primary}) => (primary ? '1px solid #88b3c6' : '1px solid #283b71')};

    &:hover{
        transition: all 0.2s ease-in-out;
        background: ${({primary}) => (primary ? '#fff':'#88b3c6')};
        border: ${({primary}) => (primary ? '1px solid #283b71' : '1px solid #88b3c6')};
    }
`